"use client";

import { ReactNode } from "react";
import classNames from "classnames";

import { Intro } from "@/components/Intro";
import { Wrapper } from "@/components/Wrapper";

import "./styles.scss";

interface PublicPageTemplateProps {
  title: string;
  subtitle?: string | ReactNode;
  children: ReactNode;
  className?: string;
}

export const PublicPageTemplate = ({
  title,
  subtitle,
  children,
  className = "",
}: PublicPageTemplateProps) => {
  const classes = classNames("u-box", {
    [className]: className,
  });

  return (
    <main>
      <Intro
        title={title}
        subtitle={subtitle}
      />
      <Wrapper
        customClass="public-page-template__wrapper"
        staticPage>
        <div className={classes}>{children}</div>
      </Wrapper>
    </main>
  );
};
